module.exports = __webpack_public_path__ + "56a743590a43805ba2d5f5a7e90aa95e.png";